import React, { useState } from 'react';
import { Button, Modal, Space, Spin, Table, Tag, Typography } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { sendEvent } from '../../../../../../Utils/analytics';
import BluetoothEdit from './BluetoothEdit';
import { calcOrder } from '../../../../../components/core/calcOrder';
import dayjs from 'dayjs';
import { sdk } from '../../../../../../API/TT_ELD/mobile/sdk';

type numStr = string | number;
const { Paragraph } = Typography;
interface contactSource {
  id: numStr;
  no: numStr;
  name: numStr;
  is_active?: boolean;
  is_supported?: boolean;
  isStable?: boolean;
  createdAt: numStr;
  version: numStr;
  type: numStr;
  note: string;
  url?: numStr;
  key: React.Key;
}

const { confirm } = Modal;

const BluetoothTable = ({
  data = [],
  onChange,
  total = 0,
  isLoading,
  skip,
  isFetching,
  refetch,
  status,
}: {
  data: Array<any> | undefined;
  onChange(current: any): void;
  total: number | undefined;
  isLoading: boolean | undefined;
  isFetching: any;
  skip: number;
  refetch: any;
  status: boolean;
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [getOneData, setGetOneData] = useState<contactSource>();
  const [expandedNote, setExpandedNote] = useState<string | null>(null);
  const handleCancel = (record: any) => {
    setGetOneData(record);
  };
  const columns: object[] = [
    {
      title: 'No',
      dataIndex: 'no',
      key: 'no',
      width: '5%',
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      width: '20%',
    },

    {
      title: 'Version',
      dataIndex: 'version',
      key: 'version',
      width: '10%',
    },
    {
      title: 'Supported',
      dataIndex: 'is_supported',
      key: 'is_supported',
      width: '10%',
      render: (value: boolean) => (
        <Tag color={value ? 'blue' : 'default'}>{value ? 'Supported' : 'Not Supported'}</Tag>
      ),
    },
    {
      title: 'Stable',
      dataIndex: 'isStable',
      key: 'isStable',
      width: '10%',
      render: (value: boolean) => (
        <Tag color={value ? 'green' : 'default'}>{value ? 'Stable' : 'Not Stable'}</Tag>
      ),
    },
    {
      title: 'Created at',
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: '20%',
      render: (value: string) => dayjs(value).format('MMM DD, YYYY  HH:mm:ss'),
    },

    {
      title: 'Note',
      dataIndex: 'note',
      key: 'note',
      width: '20%',
      render: (note: string) => (
        <Paragraph
          ellipsis={expandedNote === note ? false : { rows: 2, expandable: true, symbol: '' }}
          onClick={() => setExpandedNote(expandedNote === note ? null : note)}
          style={{ cursor: 'pointer' }}
        >
          {note}
        </Paragraph>
      ),
    },
    {
      title: 'Actions',
      dataIndex: 'info',
      key: 'info',
      align: 'center',
      width: '15%',
      render: (_: any, record: { id: number | string; role: string }) => {
        const showConfirm = () => {
          confirm({
            title: 'Delete',
            icon: <ExclamationCircleFilled rev={undefined} />,
            content: 'Do you want to  delete this user ?',

            onOk: async () => {
              return new Promise(async (resolve, reject) => {
                setTimeout(Math.random() > 0.5 ? resolve : reject, 1000);
                await sdk.deleteSDK(record.id);

                sendEvent('Approval', 'User accept', '', 1);
                refetch();
              }).catch(() => {});
            },
            onCancel() {},
          });
        };
        const showModal = () => {
          setIsModalOpen(true);
        };
        return (
          <Space>
            <Button onClick={showModal}>Edit</Button>
            {!status && (
              <Button danger onClick={showConfirm}>
                Delete
              </Button>
            )}
          </Space>
        );
      },
    },
  ];

  return (
    <div>
      <Spin size="large" spinning={isLoading || isFetching}>
        {isModalOpen && (
          <BluetoothEdit
            isModalVisible={isModalOpen}
            setIsModalVisible={setIsModalOpen}
            refetchData={refetch}
            getOneData={getOneData}
          />
        )}

        <Table
          style={{ margin: '15px 0 0 0' }}
          onRow={(record: any) => {
            return {
              onClick: () => {
                handleCancel(record);
              },
            };
          }}
          onChange={onChange}
          dataSource={data?.map((u: any, i: number): contactSource => {
            const obj: contactSource = {
              id: u.id,
              no: calcOrder(skip, 10, i),
              name: u?.name,
              type: u.type,
              is_active: u?.is_active,
              is_supported: u?.is_supported,
              isStable: !!u?.isStable,
              url: u?.url,
              createdAt: u.createdAt,
              version: u?.version,
              note: u?.note,
              key: u.id,
            };
            return obj;
          })}
          columns={columns}
          pagination={{ total: total, showSizeChanger: false, current: skip }}
          scroll={{ x: 'max-content' }}
        />
      </Spin>
    </div>
  );
};

export default BluetoothTable;
